// extracted by mini-css-extract-plugin
module.exports = {"container":"List_container__El7DC","note":"List_note__19AEi","text":"List_text__34RsQ","meta":"List_meta__134Ru","btn":"List_btn__3vmfI"};